<div class="center">
    <ng-container *ngTemplateOutlet="dragdealer;context: {items: hours,property: 'hours'}"></ng-container>
    <ng-container *ngTemplateOutlet="dragdealer;context: {items: minutes,property: 'minutes'}"></ng-container>
</div>

<ng-template #dragdealer let-items="items" let-property="property">
    <div class="dragdealer" (mousedown)="start($event)" (mousemove)="move($event, property)" (mouseup)="leave(property)" (mouseleave)="leave(property)" 
    (touchstart)="start($event)" (touchmove)="move($event, property)" (touchend)="leave(property)">
        <ul class="handler" [style]="getStyle(property)">
            <ng-container *ngFor="let item of items">
                <li (click)="goToValue(item, property)">{{item | padStart:2}}</li>
            </ng-container>
        </ul>
    </div>
</ng-template>
